import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { classNames } from '../../utils/classNames';
import {
    extraNavigation,
} from '../../utils/navigation-constants/navigation-partner';
import { PartnerGuard } from '../../guards/RolesGuard';

interface INavigation {
    search?: string
}

const Navigation = ({
    search
}: INavigation) => {
    // const location = useLocation();
    const [activeRoute] = useState<string>()
    const [navigationPartnerExtra] = useState<any>(extraNavigation)
    const [loading] = useState<boolean>(false)


    return (
        <div className='flex flex-col min-h-[100%] justify-between'>

            <>
                {PartnerGuard() &&
                    <div className=''>
                        {/* <p className='mb-3 text-[#8a8a8e] text-[13px]'>History</p> */}
                        <p className='mb-3 text-[#8a8a8e] dark:text-primary-dark text-[13px]'>AI Agents</p>
                        <div className='bg-[#F5F5F5] dark:bg-black rounded-lg my-3 flex flex-row items-center p-2 cursor-pointer hover:opacity-80'>
                            <img src={'/assets/agents/charles-agent.svg'} className={'object-contain w-[25px] !rounded-lg mr-2'} />
                            <p className='dark:text-primary-dark'>Charles</p>
                            <p className='text-primary-light truncate ml-2'>Accounting AI Agent</p>
                        </div>
                    </div>
                }
                <div className='mb-1 pt-2'>

                    {!loading && navigationPartnerExtra?.map((item: any) => (
                        <NavLink
                            key={item.name}
                            to={item.href}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            className={({ isActive }) =>
                                classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2',
                                    item.enabled && isActive
                                        ? 'font-dm_sansregular !text-[#202020]   !rounded-lg'
                                        : 'font-dm_sansregular',
                                )
                            }
                        >
                            {/* <item.icon className='mr-3 flex-shrink-0 h-6 w-6 text-indigo-300' aria-hidden='true' /> */}
                            <span className='flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center'>
                                {activeRoute === item?.href ?
                                    React.cloneElement(item.iconActive || item.icon, {
                                        width: 20,
                                        height: 20,
                                    })
                                    : React.cloneElement(item.icon, {
                                        width: 20,
                                        height: 20,
                                    })
                                }
                            </span>
                            {item.name}
                        </NavLink>
                    ))}
                </div>
            </>

        </div>
    );
};

export default Navigation;